import { User, signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../firebase';

export const SignIn: (
    email: string,
    password: string,
) => Promise<User | undefined> = async (email, password) => {
    let toReturn: User | undefined = undefined;

    await signInWithEmailAndPassword(auth, email, password)
        .then((res) => {
            toReturn = res.user;
        })
        .catch((err) => {
            throw err;
        });

    return toReturn;
};
